import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-6 mt-6" }
const _hoisted_2 = { class: "col-span-4 sm:col-span-2" }
const _hoisted_3 = {
  class: "block text-sm font-medium text-gray-700",
  for: "vocalPart"
}
const _hoisted_4 = { class: "col-span-4 sm:col-span-2" }
const _hoisted_5 = {
  class: "block text-sm font-medium text-gray-700",
  for: "dancingLevel"
}
const _hoisted_6 = {
  key: 0,
  class: "col-span-4 sm:col-span-2"
}
const _hoisted_7 = {
  key: 1,
  class: "col-span-4 sm:col-span-2"
}
const _hoisted_8 = { class: "grid md:grid-cols-2 gap-x-8" }
const _hoisted_9 = { class: "mt-10 divide-y divide-gray-200" }
const _hoisted_10 = { class: "space-y-1" }
const _hoisted_11 = { class: "text-xl font-bold leading-6 text-gray-900" }
const _hoisted_12 = { class: "mt-6" }
const _hoisted_13 = { class: "divide-y divide-gray-200" }
const _hoisted_14 = { class: "grid grid-cols-4 gap-6 mt-6" }
const _hoisted_15 = { class: "col-span-4" }
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = { class: "mt-10 divide-y divide-gray-200" }
const _hoisted_18 = { class: "mt-6" }
const _hoisted_19 = { class: "divide-y divide-gray-200" }
const _hoisted_20 = { class: "grid grid-cols-4 gap-6 mt-6" }
const _hoisted_21 = { class: "col-span-4" }
const _hoisted_22 = { class: "mt-1" }
const _hoisted_23 = { class: "py-3 mt-10 text-center" }

import {computed, onBeforeMount, Ref, ref} from "vue";
import {client} from '@/shared';
import {GetProfileSettingSkills, GetProfileSettingSkillsResponse, UpdateProfileSkills, YourBookmarkDto} from "@/dtos";
// @ts-ignore
import {SparklesIcon, TrashIcon} from '@heroicons/vue/20/solid';
import {ResponseStatus} from "@servicestack/client";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SaCombobox from "@/main/components/SaCombobox.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileSkillsSettings',
  setup(__props) {

// @ts-ignore
let responseStatus = ref(null);
let profile: Ref<GetProfileSettingSkillsResponse> = ref(new GetProfileSettingSkillsResponse());
let updateSuccessful: Ref<Boolean> = ref(false);

onBeforeMount(async () => {
    await client.get<GetProfileSettingSkillsResponse>(new GetProfileSettingSkills())
        .then(response => {
            profile.value = response;
        });
});

const displayVocalRanges = computed(() =>{
    return profile.value.vocalPart 
        && profile.value.vocalPart !== '' 
        && profile.value.vocalPart !=='Non-singer';
});

const isSubmitting = ref(false);
const submit = async () => {
    isSubmitting.value = true;
    let request = profile.value;
    await client.post<ResponseStatus>(new UpdateProfileSkills(request))
        .then(_ => {
            updateSuccessful.value = true;
            responseStatus.value = null;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", null, [
      _createVNode(ErrorSummary, { "response-status": _unref(responseStatus) }, null, 8, ["response-status"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, [
            _cache[6] || (_cache[6] = _createTextVNode("Vocal Part ")),
            _createVNode(_unref(SparklesIcon), { class: "inline w-4 h-4 mx-1 text-powder-600" })
          ]),
          _createVNode(SaCombobox, {
            id: "vocalPart",
            modelValue: _unref(profile).vocalPart,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(profile).vocalPart) = $event)),
            options: _unref(profile).vocalPartOptions,
            name: "vocalPart"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _cache[7] || (_cache[7] = _createTextVNode("Dance Skill Level ")),
            _createVNode(_unref(SparklesIcon), { class: "inline w-4 h-4 mx-1 text-powder-600" })
          ]),
          _createVNode(SaCombobox, {
            id: "dancingLevel",
            modelValue: _unref(profile).dancingLevel,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(profile).dancingLevel) = $event)),
            options: _unref(profile).dancingLevelOptions,
            name: "dancingLevel"
          }, null, 8, ["modelValue", "options"])
        ]),
        (displayVocalRanges.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                class: "block text-sm font-medium text-gray-700",
                for: "vocalRangeMin"
              }, "Vocal Range (Low Note)", -1)),
              _createVNode(SaCombobox, {
                id: "vocalRangeMin",
                modelValue: _unref(profile).vocalRangeMin,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(profile).vocalRangeMin) = $event)),
                options: _unref(profile).vocalRangeOptions,
                name: "vocalRangeMin"
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true),
        (displayVocalRanges.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                class: "block text-sm font-medium text-gray-700",
                for: "vocalRangeMin"
              }, "Vocal Range (High Note)", -1)),
              _createVNode(SaCombobox, {
                id: "vocalRangeMax",
                modelValue: _unref(profile).vocalRangeMax,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(profile).vocalRangeMax) = $event)),
                options: _unref(profile).vocalRangeOptions,
                name: "vocalRangeMax"
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", _hoisted_11, [
              _cache[10] || (_cache[10] = _createTextVNode("Education / Training ")),
              _createVNode(_unref(SparklesIcon), { class: "inline w-4 h-4 mx-1 text-powder-600" })
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "max-w-2xl text-sm text-clay-800" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", {
                    class: "block text-sm font-medium text-gray-700 sr-only",
                    for: "educationOrTraining"
                  }, "List your education and training", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("textarea", {
                      id: "educationOrTraining",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(profile).educationOrTraining) = $event)),
                      class: "block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-500 sm:text-sm",
                      name: "educationOrTraining",
                      rows: "4"
                    }, null, 512), [
                      [_vModelText, _unref(profile).educationOrTraining]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "space-y-1" }, [
            _createElementVNode("h3", { class: "text-xl font-bold leading-6 text-gray-900" }, "Special Skills"),
            _createElementVNode("p", { class: "max-w-2xl text-sm text-clay-800" })
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    class: "block text-sm font-medium text-gray-700 sr-only",
                    for: "specialSkills"
                  }, "List your special skills", -1)),
                  _createElementVNode("div", _hoisted_22, [
                    _withDirectives(_createElementVNode("textarea", {
                      id: "specialSkills",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(profile).specialSkills) = $event)),
                      class: "block w-full px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-500 sm:text-sm",
                      name: "specialSkills",
                      rows: "4"
                    }, null, 512), [
                      [_vModelText, _unref(profile).specialSkills]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(SaButton, {
          onClick: _withModifiers(submit, ["prevent"]),
          loading: isSubmitting.value,
          variant: "primary"
        }, null, 8, ["loading"])
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: _unref(updateSuccessful),
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})